import { ChangeDetectionStrategy, Component } from '@angular/core';
import { productsHeader } from '@pages/main/db/main.db';
import { MainImports } from '@pages/main/main.imports';
import { ISection } from '@shared/interfaces/section.interface';

@Component({
  selector: 'noda-main',
  standalone: true,
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: MainImports,
})
export class MainComponent {
  protected productsDate: ISection = productsHeader;
}
